import AdminSitesSummary from './container'

export default AdminSitesSummary
